import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from './ArticleImage.scss';

export default class ArticleImage extends Component {
  static propTypes = {
    src    : PropTypes.string.isRequired,
    alt    : PropTypes.string,
    caption: PropTypes.string,
  }

  render() {
    const { src, alt, caption } = this.props;

    return (
      <div className={classNames(classes.articleImage, { [classes.articleImageWithCaption]: !!caption })}>
        {
          caption &&
            <h2 className={classes.caption}>{caption}</h2>
        }
        <div className={classes.imageContainer}>
          <img src={src} alt={alt} className={classes.image} />
        </div>
      </div>
    );
  }
}
